/* eslint-disable no-unreachable */
/* eslint-disable no-unused-vars */

import React from 'react';
import reduce from 'lodash-es/reduce';
import map from 'lodash-es/map';
import { ProgressItems } from 'components/modal/progressModal';
import { UploadItems, UploadResponse } from 'store/types';
import { BASE_URL, currentAuthHeader } from 'api/Api';
import { PreviewMap } from './upload';
import { getMIMEType, tagsToString } from 'utils/utils';

export default async function processFiles({
  setProgressItems,
  setIsUploading,
  fileList,
  category,
  onRequestInit,
  previewList,
  previewMap,
}: {
  setProgressItems: (value: React.SetStateAction<ProgressItems>) => void;
  setIsUploading: (value: React.SetStateAction<boolean>) => void;
  fileList: UploadItems;
  previewList: UploadItems;
  previewMap: PreviewMap;
  category: string;
  onRequestInit: (promise: Promise<UploadResponse>) => void;
}) {
  setIsUploading(true);

  setProgressItems(
    reduce(
      fileList,
      (acc: ProgressItems, item) => {
        acc[item.id] = {
          id: item.id,
          description: item.originalName,
          status: 'pending',
          percent: 0,
        };

        return acc;
      },
      {}
    )
  );

  await Promise.all(
    map(fileList, async (item) => {
      const formData = new FormData();
      formData.append('name', item.originalName);
      formData.append('category', category);
      formData.append(
        'resource',
        item?.binary
          ? new Blob([item.binary], { type: getMIMEType(item.file.name) })
          : ''
      );
      formData.append('tags', JSON.stringify(item.tags));

      const previewName = previewMap[item.id];
      const previewItem = previewList[previewName];

      if (previewItem) {
        formData.append(
          'preview',
          previewItem?.binary
            ? new Blob([previewItem.binary], {
                type: getMIMEType(previewItem.file.name),
              })
            : ''
        );
      }

      const xhr = new XMLHttpRequest();
      xhr.open(
        'POST',
        `${BASE_URL}/resource/create?tags=${tagsToString(item.tags)}`
      );
      xhr.setRequestHeader('Authorization', currentAuthHeader);
      xhr.responseType = 'json';

      xhr.upload.onprogress = (e) => {
        setProgressItems((old) => {
          return {
            ...old,
            [item.id]: {
              ...old[item.id],
              percent: Math.ceil((e.loaded / e.total) * 100),
            },
          };
        });
      };

      const promise = new Promise<UploadResponse>((resolve, reject) => {
        xhr.onload = function () {
          setProgressItems((old) => {
            return {
              ...old,
              [item.id]: {
                ...old[item.id],
                status: 'fulfilled',
              },
            };
          });
          resolve(xhr.response);
        };

        xhr.onerror = function () {
          setProgressItems((old) => {
            return {
              ...old,
              [item.id]: {
                ...old[item.id],
                status: 'rejected',
              },
            };
          });
          reject(xhr.response);
        };
      });

      xhr.send(formData);
      onRequestInit(promise);

      return promise;
    })
  );

  setIsUploading(false);
}
